import consumer from "./consumer"

const currentUserMeta = document.querySelector("meta[name='current-user-id']")

if (currentUserMeta) {
  consumer.subscriptions.create("NotificationsChannel", {
    received(data) {
      window.dispatchEvent(new CustomEvent("notifications:received", { detail: data }))
    }
  })
}
